function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.51 14.62a.69.69 0 01-.57.31H2.07a.69.69 0 01-.57-.31 9.5 9.5 0 1116.01 0zM2.72 8.14A1.36 1.36 0 104.08 9.5a1.35 1.35 0 00-1.37-1.36zm2-4.75a1.36 1.36 0 101.36 1.36 1.35 1.35 0 00-1.33-1.36zm7 2.41a.69.69 0 00-.49-.83.68.68 0 00-.83.49L9.33 9.51a2 2 0 102.14 2.54 2.06 2.06 0 00-.83-2.21zM9.5 1.36a1.36 1.36 0 101.36 1.36A1.35 1.35 0 009.5 1.36zm4.75 2a1.36 1.36 0 101.36 1.36 1.35 1.35 0 00-1.36-1.33zm2 4.75a1.36 1.36 0 101.36 1.36 1.35 1.35 0 00-1.32-1.33z"
});

var SvgTachometer = function SvgTachometer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 19 14.93"
  }, props), _ref);
};

export default SvgTachometer;